<template>
    <div class="publication__cards content-width d-flex">
        <div class="publication__card d-flex"
             :class="{'publication__card--selected': selected === _item.id}" v-for="(_item, _idx) in categoriesServer">

            <div class="publication__card-left">
                <div class="publication__card-header  d-flex">
                    <img :src="_item.icon" class="publication__card-icon" alt="" v-if="_item.icon">
                    <h3 class="publication__card-title" v-text="_item.name"></h3>
                </div>

            </div>
            <div class="publication__card-right d-flex">
                <a :href="_item.link" class="btn publication__btn" v-if="_item.link">Выбрать</a>
                <a href="#" class="btn publication__btn" v-if="selected !== _item.id"
                   @click.prevent="$v.selected.$model = _item.id;"
                   >Выбрать</a>
                <a href="#" @click.prevent="$v.selected.$model = null"
                   class="btn publication__btn publication__btn--selected" v-if="selected === _item.id">Отмена</a>
            </div>

        </div>

        <div class="text-danger" v-if="$v.selected.$error" >Укажите тип обьявления.</div>

    </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PublicationCreateProject",
    props: ['server'],
    mixins: [StateMixin],

    computed: {
        categoriesServer(){ return this.server.dictionaries.project_category_id },

        selected: {
            get() { return this.GET_BY_KEY('project_category_id') },
            set( val ) {
                this.SET_BY_KEY({key: 'project_category_id', data: val})
            }
        }

    },

    methods:{
        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return  false
            }

            this.$emit('parent-update', true )
            return  true
        }

    },

    validations: { selected: { required } }


}
</script>

<style lang="scss" scoped>

.publication__card{
    align-items: center;
}

.publication__card-header{
    margin-bottom: 0;
}
</style>
